module.exports = __webpack_public_path__ + "documents/SHS_Tech_Coach_Terms_of_Service.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/SHS_Tech_Coach_Terms_of_Service.pdf
// module id = 3524
// module chunks = 0